import React, { useCallback, useEffect, useState } from 'react';

import { collection, query, where, getDocs } from 'firebase/firestore';
import QRCode from 'react-qr-code';
import { DB } from '~/services/firebase';
import { useAuth } from '~/hooks/auth';
import ITable from '~/interfaces/ITable';

const { REACT_APP_WEB_URL } = process.env;

const breaks = Array.from({ length: 100 }).map((_, index) => 3 + index * 4);

const PrintQrCode: React.FC = () => {
  const { user, company } = useAuth();
  const [tables, setTables] = useState<ITable[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const q = query(collection(DB, 'tables'), where('user_id', '==', user.uid));
    const querySnapshot = await getDocs(q);

    const items: ITable[] = [];

    querySnapshot.docs.forEach((item, index) => {
      const parseItem = {
        ...item.data(),
        uid: item.id,
      } as ITable;

      items.push(parseItem);
    });

    items.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

    setTables(items);

    setTimeout(() => {
      setLoading(false);
      // window.print();
      // window.close();
    }, 1000);
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    $('<style>')
      .text(
        `
        @media print {
          .break {page-break-after: always;}
        }
    `,
      )
      .appendTo(document.head);
  }, []);

  return (
    <>
      {!loading && (
        <div className="row">
          {tables.map((item, index) => (
            <>
              <div
                className={`col-6 d-flex flex-column justify-content-center align-items-center mb-3 ${
                  breaks.includes(index) ? 'break' : ''
                }`}
              >
                <h1>Faça seu pedido</h1>
                <h3>{`Mesa: ${item.name}`}</h3>
                <QRCode
                  title={`Mesa: ${item.name}`}
                  value={`${REACT_APP_WEB_URL}${company.app_domain}?table=${item.uid}`}
                  size={250}
                />
              </div>
              {breaks.includes(index) && (
                <>
                  <div className="pagebreak" style={{ height: 280 }} />
                </>
              )}
            </>
          ))}
        </div>
      )}

      {loading && (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: '100vh' }}
        >
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="sr-only" />
          </div>
          Carregando...
        </div>
      )}
    </>
  );
};

export default PrintQrCode;
